import type { PlayStartReason, PlayStopReason } from '../index.h'

import { createEvent } from 'effector'

/**
 * Immutable playback state snapshot captured at emit time.
 * Used by analytix parameter maps/events to avoid reading unstable player APIs.
 */
export type PlaybackSnapshot = {
  playerId: string
  currentTime: string
  contentLength: string
  httpErrorCode: string
  contentErrorCode: string
  audioTrackLanguage: string
  subtitlesLanguage: string
  videoQuality: string
  playbackSessionId: string
}

/**
 * Logical analytics signal: playback started/resumed with resolved reason.
 */
export const playStart = createEvent<{
  reason: PlayStartReason
  snapshot: PlaybackSnapshot
  isFirstPlay: boolean // `isFirstPlay` is true only for the first `play_start`
}>()

/**
 * Logical analytics signal: playback stopped/interrupted with resolved reason.
 */
export const playStop = createEvent<{
  reason: PlayStopReason
  snapshot: PlaybackSnapshot
}>()
